let apis = new window.yxpapi.API({
  getAllSubject: {
    // url: '/api/knowledge/book/volumne/getAllSubjectByPeriod',
    url: '/api/biz/common/periodSubjectList',
    // url: 'http://yapi.dev.anoah.com/mock/1248/api/biz/common/periodSubjectList',
    // url: '/api/knowledge/book/volumne/getSubjectAndPeriodByOrgId',
    method: 'get',
  },
}, { baseURL: '' }
);

export default apis;
